<template>
	<div>
		<action-sidebar
			:title="`Bloqueo periodo ${code}`"
			:value="true"
			@close-modal="closeModal"
		>
			<accounting-period-lock-form :id="id" @on-close="closeModal" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accountingPeriodLockForm from '@/components/accounting-periods/accounting-period-lock-form';

function closeModal() {
	this.goTo(
		'accounting-periods',
		{
			params: {
				subsidiaryId: this.subsidiaryId,
				subsidiaryName: this.subsidiaryName,
			},
		},
	);
}

export default {
	name: 'page-accounting-period-edit',
	components: {
		actionSidebar,
		accountingPeriodLockForm,
	},
	methods: {
		closeModal,
	},
	props: {
		id: [Number, String],
		code: [Number, String],
		subsidiaryId: [Number, String],
		subsidiaryName: String,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-periods/page-accounting-period-lock.vue